<template>
  <div>
    <Menu />
    <div>
      <RouteStepper :steps="steps" />
      <div class="brandComponentsContainer">
        <BrandUploadedFilesComponent 
          :brand="brand" 
          :clients="clients" 
          :accounts="accounts" 
          :accountView="accountView"
          :designerView="designerView" 
        />
        <BrandMainComponent 
          :timeline="timeline" 
          :brand="brand"
          :clients="clients"
          :accounts="accounts" 
          :accountView="accountView" 
          :designerView="designerView" 
          :c_slug="$route.params.campaign_slug" 
          :b_slug="$route.params.board_slug"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Menu from '@/components/Menu.vue'
import RouteStepper from '@/components/RouteStepper';
import BrandMainComponent from '@/components/pagesComponents/brand/BrandMainComponent';
import BrandUploadedFilesComponent from '@/components/pagesComponents/brand/BrandUploadedFilesComponent';

import viewMI from '@/mixins/viewMI.js'
export default {
    mixins: [viewMI],
    data() {
      return {
        timeline: [],
        brand: {},
        clients: [],
        accounts: [],
        steps: [],
        accountView : false,
        designerView : false,
      }
    },
    components:{
        BrandUploadedFilesComponent,
        BrandMainComponent,
        Menu,
        RouteStepper,                       
    },
    methods: {
      userReady(){
        if (this.$store.state.user.user_type == 'account' || this.$store.state.user.user_type == 'administrator' )
          this.accountView = true;
          if (this.$store.state.user.user_type == 'designer'  )
          this.designerView = true;
        this.refreshBrand();
        
                    
      },
      refreshClients(){
        var _this = this;
        _this.get('user',{params:{where:[['where','user_type','client']]}},function(resp){
          _this.clients  =resp.data.user;
          _this.$forceUpdate()
        },function(){})
      },
      refreshAccounts(){
        var _this = this;
        _this.get('user',{params:{where:[['where','user_type','account']]}},function(resp){
          _this.accounts  =resp.data.user;
          _this.$forceUpdate()
        },function(){})
      },
      refreshBrand(successCallback){
        // console.log('rb brand')
        var _this = this;
        //console.log('rB');
        this.get('brand',{params: {
          where: [
            ['where','slug',_this.$route.params.brand_slug]
          ],
          relations:1,
          relations_params:{
            user: {
              //where : (_this.$store.state.user.user_type == 'client') ? [['where','user_type','client']] : [['where','user_type !=','asdasdas']]
            },
            campaign: {
              relations:1,
              order_by:[['created_at','desc']],
              relations_params:{
                board: {
                  relations: 1,
                  relations_params:{
                    creative: {
                      where: [['where','parent_id','0'],['where','internal',0]],
                      relations: 1,
                      relations_params:{
                        comment:{
                          relations: 1
                        }
                      }
                    }
                  }
                }
              }
            }
          },
         
        }},function(resp){
          _this.brand = resp.data.brand[0];
          _this.refreshTimeline();
          _this.steps = [
            {'name':'Clients',path: "/dashboard"}
          ];
          _this.steps.push({
            name: _this.brand.client.name,path:'/client/'+_this.brand.client.slug
          })
          _this.steps.push({
            name: _this.brand.name,path:'#'
          })
          //console.log(_this.steps);
          if (successCallback) {
            successCallback(_this.brand);
          }
          _this.$forceUpdate();
        })
      },
    },
    
}

</script>